export default function HeroSection() {
  return (
    <section className="hero-plan ">
        
      <div className="contanier ">
        <div className="hero-plan-content">
            <h1>Choose Your Listing Plan</h1>
            <p>       
                Create your dedicated vendor webpage, showcase your packages, build global trust with pilgrims, and begin receiving direct enquiries and bookings through the world’s first Hajj and Umrah marketplace.
            </p>

        <button className="primary-btn">
        Create your Tour Operator Page
        </button>
        </div>
      </div>
    </section>
  );
}